import React from 'react'
import '../style/ProductInfo.css'

const ProductInfo = (props) => {


    return (
        <div className="productInfo">
            <div className="decreasedPriceBox">
                <span> $50 reduced </span>
            </div>
            <div className="productInfoTop">
                <img src="./img/threeDots.svg" className="threeDotsIcon" alt="threeDotsIcon"/>
                <img src="./img/laptop.svg" className="productImg" alt="product" alt="product image"/>
            </div>
            <div className="productInfoBottom">
                <div className="top">
                    <div className="productTitle"> {props.item.name} </div>
                    <div className="productDescription" > {props.item.description} </div>
                </div>
                <div className="bottom">
                    <button className="productDeleteBtn" onClick={() => props.deleteItem(props.item.id)}><img src="/img/crossIcon.svg" className="cross-icon" alt="icon" /> <span> Remove </span> </button>
                </div>
            </div>
         </div>
    )
}


/*



*/

export default ProductInfo